(function () {
  'use strict';

  var MAX_RETRIES = 30;
  var RETRY_MS   = 200;

  function hide(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function visuallyHide(el) {
    if (!el) return;
    el.style.setProperty('position',    'absolute',      'important');
    el.style.setProperty('width',       '1px',           'important');
    el.style.setProperty('height',      '1px',           'important');
    el.style.setProperty('padding',     '0',             'important');
    el.style.setProperty('margin',      '-1px',          'important');
    el.style.setProperty('overflow',    'hidden',        'important');
    el.style.setProperty('clip',        'rect(0,0,0,0)', 'important');
    el.style.setProperty('white-space', 'nowrap',        'important');
    el.style.setProperty('border',      '0',             'important');
  }

  function injectForm(anchor) {
    if (document.getElementById('sprint-notify-form-wrap')) return;

    var wrap = document.createElement('div');
    wrap.className = 'sprint-prelaunch-form';
    wrap.id        = 'sprint-notify-form-wrap';
    wrap.innerHTML =
      '<p class="sprint-prelaunch-form__label">We’re Not Shipping Yet – You can find us at select tournaments and camps in the Pacific Northwest this Summer. Until then, enter your email to be first to know when we launch.</p>' +
      '<p class="sprint-prelaunch-form__sublabel">Join the Team, Be First to the Scale</p>' +
      '<form class="sprint-prelaunch-form__form" id="sprint-notify-form" novalidate>' +
      '  <div class="sprint-prelaunch-form__row">' +
      '    <input type="email" id="sprint-notify-email" name="email" placeholder="your@email.com" required autocomplete="email" class="sprint-prelaunch-form__input">' +
      '    <button type="submit" class="sprint-prelaunch-form__btn">Notify Me</button>' +
      '  </div>' +
      '  <p class="sprint-prelaunch-form__success" id="sprint-notify-success" hidden>✓ You’re on the list! We’ll email you when we launch.</p>' +
      '  <p class="sprint-prelaunch-form__error" id="sprint-notify-error" hidden>Something went wrong — please try again.</p>' +
      '</form>';

    // Gold label text
    var label = wrap.querySelector('.sprint-prelaunch-form__label');
    if (label) {
      label.setAttribute('style',
        'color: #D4A24C !important;'
      );
    }

    // Force white input
    var input = wrap.querySelector('.sprint-prelaunch-form__input');
    if (input) {
      input.setAttribute('style',
        'background: #ffffff !important;' +
        'color: #0a0a0a !important;' +
        '-webkit-text-fill-color: #0a0a0a !important;' +
        'border-color: rgba(0,0,0,0.25) !important;'
      );
    }

    // Sublabel — smaller, italic, muted
    var sublabel = wrap.querySelector('.sprint-prelaunch-form__sublabel');
    if (sublabel) {
      sublabel.setAttribute('style',
        'font-size: 12px;' +
        'font-style: italic;' +
        'color: rgba(250,250,250,0.55);' +
        'margin: 6px 0 16px;'
      );
    }

    // Smart insertion
    var isContainer = anchor.classList &&
      (anchor.classList.contains('group-block-content') ||
       anchor.classList.contains('product-details'));

    if (isContainer) {
      anchor.appendChild(wrap);
    } else {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    }

    var form       = document.getElementById('sprint-notify-form');
    var emailInput = document.getElementById('sprint-notify-email');
    var successMsg = document.getElementById('sprint-notify-success');
    var errorMsg   = document.getElementById('sprint-notify-error');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorMsg.hidden = true;
      emailInput.setAttribute('style',
        'background: #ffffff !important;' +
        'color: #0a0a0a !important;' +
        '-webkit-text-fill-color: #0a0a0a !important;' +
        'border-color: rgba(0,0,0,0.25) !important;'
      );
      var email = emailInput.value.trim();
      if (!email || !/.+@.+\..+/.test(email)) {
        emailInput.setAttribute('style',
          'background: #ffffff !important;' +
          'color: #0a0a0a !important;' +
          '-webkit-text-fill-color: #0a0a0a !important;' +
          'border-color: #ff6b6b !important;'
        );
        emailInput.focus();
        return;
      }
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled    = true;
      btn.textContent = 'Submitting…';
      var body = new FormData();
      body.append('form_type',      'customer');
      body.append('utf8',           '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]',  'prelaunch-notify');
      fetch('/contact', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (res) {
          if (res.ok || res.status === 200 || res.status === 302) {
            form.querySelector('.sprint-prelaunch-form__row').style.display = 'none';
            successMsg.hidden = false;
          } else { throw new Error('server'); }
        })
        .catch(function () {
          errorMsg.hidden = false;
          btn.disabled    = false;
          btn.textContent = 'Notify Me';
        });
    });
  }

  function hideAll() {
    document.querySelectorAll('.buy-buttons-block').forEach(hide);
    document.querySelectorAll('product-form-component').forEach(hide);
    document.querySelectorAll('fieldset[data-fieldset-index="1"]').forEach(visuallyHide);
  }

  function findAnchor(picker) {
    var section = picker.closest('[id^="shopify-section-"]') || document.body;

    var rteEl = section.querySelector('rte-formatter');
    if (rteEl) return rteEl;

    var rte = section.querySelector('.rte');
    if (rte) return rte;

    var el = picker;
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains('group-block-content')) {
        return el;
      }
      el = el.parentNode;
    }

    var productDetails = section.querySelector('.product-details');
    if (productDetails) return productDetails;

    return picker;
  }

  function init(attempt) {
    if (attempt === undefined) attempt = 0;
    hideAll();
    var picker = document.querySelector('variant-picker');
    if (picker) {
      injectForm(findAnchor(picker));
      return;
    }
    if (attempt < MAX_RETRIES) {
      setTimeout(function () { init(attempt + 1); }, RETRY_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }

  document.addEventListener('shopify:section:load', function () {
    var existing = document.getElementById('sprint-notify-form-wrap');
    if (existing) existing.remove();
    init(0);
  });
})();
